import { render } from "./DashboardStatCard.vue?vue&type=template&id=18a28148"
import script from "./DashboardStatCard.vue?vue&type=script&lang=js"
export * from "./DashboardStatCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__